
                  export default function (Component) {
                      Component.__source = "library/components/VabRouterView/index.vue"
                  }
              